module.exports = __webpack_public_path__ + "static/media/clayton.86955ee2.png";